// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3pIJk","location":"Header_location__3urxQ"};